const ERROR_MESSAGE_DURATION = 3500;

function trim(str) {
  if (!str || !str.length) return str;
  return str.replace(/(^\s*)|(\s*$)/g, '');
}

function showValidError(msg) {
  this.$message({
    dangerouslyUseHTMLString: true,
    showClose: true,
    message: `校验错误：<br/>${msg}`,
    type: 'error',
  });
}

function showSuccess(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: 'success',
  });
}

function showError(err, type, msgType) {
  let errMsg;
  if (typeof err === 'string') {
    errMsg = err;
  } else if (typeof err === 'object') {
    errMsg = err && err.message
      ? err.message
      : err.data && err.data.error
        ? err.data.error.msg
        : null;
  }
  this.$message({
    message: `${type ? `${type}:` : ''}${errMsg || '未知原因'}`,
    type: msgType || 'error',
    duration: ERROR_MESSAGE_DURATION,
    dangerouslyUseHTMLString: true,
  });
}

function showWarning(err) {
  showError.call(this, err, '', 'warning');
}

function isInt(str) {
  if (str === '0' || str === 0) return true;
  if (!str) return false;
  const numStr = typeof str !== 'string' ? (str && str.toString ? str.toString() : '') : str;
  return /^\d+$/.test(numStr);
}

function isFloat(str, fixed = 2) {
  if (str === '0' || str === 0) return true;
  if (!str) return false;
  const numStr = typeof str !== 'string' ? (str && str.toString ? str.toString() : '') : str;
  return new RegExp(`^\\d+(\\.\\d{1,${fixed}})?$`).test(numStr);
}

function handleObjParams(obj) {
  if (typeof obj !== 'object') return;
  if (!Object.keys(obj).length) return obj;
  const result = [];
  Object.entries(obj).forEach(([key, value]) => {
    result.push(`${key}=${value}`);
  });
  return result.join('&');
}

export function dateToStr(date, hasTime) {
  const d = date || new Date();
  const year = d.getFullYear();
  const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
  const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
  const hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
  const minute = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
  const second = d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds();
  if (hasTime) {
    // 可传第二个参数false，返回yyyy-MM-dd
    return `${[year, month, day].join('-')} ${[hour, minute, second].join(
      ':',
    )}`;
  }
  return [year, month, day].join('-');
}

export function secondsToDateStr(seconds, hasTime = true) {
  const date = new Date(seconds * 1000);
  return dateToStr(date, hasTime);
}

export const HIDE_LOADING_DELAY = 400;

export const ANI_DURATION = 366;

function getEmptyArray(pageSize) {
  const arr = [];
  let i = 0;
  while (i < pageSize) {
    arr.push({});
    i++;
  }
  return arr;
}

function findItemInArray(arr, filterProps) {
  if (!arr || !arr.length) return;
  return arr.find((item) => {
    const propKeys = Object.keys(filterProps);
    if (!propKeys || !propKeys.length) return true;
    let matchFilter = true;
    for (let i = 0; i < propKeys.length; ++i) {
      const key = propKeys[i];
      const filterPropVal = filterProps[key];
      if (item[key] !== filterPropVal) {
        matchFilter = false;
        break;
      }
    }
    return matchFilter;
  });
}

function handlePngBackground(base64Url, cb) {
  const img = new Image();
  img.src = base64Url;
  img.onload = function () {
    const w = this.width;
    const h = this.height;
    const canvas = document.getElementById('ctx');
    const ctx = canvas.getContext('2d');
    const anw = document.createAttribute('width');
    anw.nodeValue = w;
    canvas.setAttributeNode(anw);
    const anh = document.createAttribute('height');
    anh.nodeValue = h;
    canvas.setAttributeNode(anh);
    ctx.drawImage(this, 0, 0, w, h);
    // 将canvas的透明背景设置成白色
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < imageData.data.length; i += 4) {
      // 当该像素是透明的，则设置成白色
      if (imageData.data[i + 3] === 0) {
        imageData.data[i] = 255;
        imageData.data[i + 1] = 255;
        imageData.data[i + 2] = 255;
        imageData.data[i + 3] = 255;
      }
    }
    const imgType = 'image/jpeg';
    ctx.putImageData(imageData, 0, 0);
    cb(canvas.toDataURL(imgType, 1));
  };
}
// 图片旋转
function handleRotateImage(base64Url, direction = 'l', cb) {
  const img = new Image();
  img.src = base64Url;
  img.onload = function () {
    const { width: W, height: H } = img;
    const cvs = document.createElement('canvas');
    cvs.width = W;
    cvs.height = H;
    const ctx = cvs.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const imgDt0 = ctx.getImageData(0, 0, W, H);
    const imgDt1 = new ImageData(H, W);
    const imgDt2 = new ImageData(H, W);
    const dt0 = imgDt0.data;
    const dt1 = imgDt1.data;
    const dt2 = imgDt2.data;

    let r = 0;
    let r1 = 0;
    for (let y = 0, lenH = H; y < lenH; y++) {
      for (let x = 0, lenW = W; x < lenW; x++) {
        r = (x + lenW * y) * 4;
        r1 = (y + lenH * x) * 4;
        dt1[r1 + 0] = dt0[r + 0];
        dt1[r1 + 1] = dt0[r + 1];
        dt1[r1 + 2] = dt0[r + 2];
        dt1[r1 + 3] = dt0[r + 3];
      }
    }

    for (let y = 0, lenH = W; y < lenH; y++) {
      for (let x = 0, lenW = H; x < lenW; x++) {
        r = (x + lenW * y) * 4;
        r1 = direction === 'l'
          ? (x + lenW * (lenH - 1 - y)) * 4
          : (lenW - 1 - x + lenW * y) * 4;
        dt2[r1 + 0] = dt1[r + 0];
        dt2[r1 + 1] = dt1[r + 1];
        dt2[r1 + 2] = dt1[r + 2];
        dt2[r1 + 3] = dt1[r + 3];
      }
    }

    cvs.width = H;
    cvs.height = W;
    ctx.clearRect(0, 0, W, H);
    ctx.putImageData(imgDt2, 0, 0, 0, 0, H, W);
    const imgType = 'image/jpeg';
    cb(cvs.toDataURL(imgType, 1));
  };
}

export default {
  install(Vue) {
    const proto = Vue.prototype;
    proto.trim = trim;
    proto.showError = showError;
    proto.showValidError = showValidError;
    proto.showSuccess = showSuccess;
    proto.dateToStr = dateToStr;
    proto.handleObjParams = handleObjParams;
    proto.secondsToStr = secondsToDateStr;
    proto.isInt = isInt;
    proto.isFloat = isFloat;
    proto.getEmptyArray = getEmptyArray;
    proto.findItemInArray = findItemInArray;
    proto.HIDE_LOADING_DELAY = HIDE_LOADING_DELAY;
    proto.ANI_DURATION = ANI_DURATION;
    proto.$error = showError;
    proto.$warning = showWarning;
    proto.$success = showSuccess;
    proto.handlePngBackground = handlePngBackground;
    proto.handleRotateImage = handleRotateImage;
  },
};



// WEBPACK FOOTER //
// ./src/utils/utilsplugin.js